export default "__VITE_ASSET__2cb6dbf9__"